import React from "react";
import { motion } from "framer-motion";

// importing stylesheets:
import "./DevlogCard.css";

// importing local assets:
import DefaultImage from "../../../../assets/logo.png";

const devlogCardVariants = (count) => ({
  hidden: { y: "-3000%", scale: 0.1, opacity: 0 },
  visible: {
    y: "0%",
    scale: 1,
    opacity: 1,
    transition: {},
  },
});

const DevlogCard = ({
  devlogInfo = {
    title: "",
    description: "",
    imgLink: "",
    visitLink: "",
  },
  count = 1,
}) => {
  return (
    <motion.a
      variants={devlogCardVariants(count)}
      initial="hidden"
      animate="visible"
      className="devlog-card-container"
      href={devlogInfo.visitLink || "/"}
      target="_blank"
      rel="noreferrer"
    >
      <div className="img-container">
        <img src={devlogInfo?.imgLink || DefaultImage} alt="devlog preview" />
      </div>
      <div className="content">
        <h3 className="title">{devlogInfo.title || "no title!"}</h3>
      </div>
    </motion.a>
  );
};

export default DevlogCard;
